import { useMemo } from 'react'
import { useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { buildFootnoteInfoByCitationId, FootnoteInfoByCitationId, getAgentReferencesForTurn } from '../util/agent-reference-footnotes'

/**
 * Returns a map from citation_id to its `FootnoteInfo` (footnote number +
 * highlight count) for the given turn. Returns `{}` when `turn_id` is null
 * (e.g., the originating turn hasn't loaded yet). React-side wrapper around
 * buildFootnoteInfoByCitationId — non-React paths should call the util directly.
 */
export function useFootnoteInfoByCitationId(turn_id: string | null, responseMessage?: string): FootnoteInfoByCitationId {
  const referencesByCitationId = useAppSelector((state: RootState) => state.agentReferencesState.references)

  return useMemo(() => {
    const turnReferences = getAgentReferencesForTurn(referencesByCitationId, turn_id)
    return buildFootnoteInfoByCitationId({ references: turnReferences, responseMessage })
  }, [referencesByCitationId, turn_id, responseMessage])
}
